import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { services } from "@/data/services";

export default function Footer() {
  const year = new Date().getFullYear();
  const half = Math.ceil(services.length / 2);
  const col1 = services.slice(0, half);
  const col2 = services.slice(half);

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111110] text-[#F4F4EB] relative grain"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-5">
              <img
                src="/logo.png"
                alt="Schaefer Services logo"
                className="h-24 md:h-28 w-auto object-contain shrink-0"
              />
              <div
                data-testid="footer-wordmark"
                className="font-display font-black uppercase tracking-tighter text-3xl md:text-4xl leading-[0.9]"
              >
                Schaefer<span className="text-[#E5231A]">.</span>
                <br />
                Services
              </div>
            </div>
            <p className="mt-5 text-[#F4F4EB]/70 max-w-sm leading-relaxed">
              Owner-operated heavy equipment and dirt work contractor serving
              Abilene, Texas and the surrounding communities.
            </p>
            <Link
              to="/#contact"
              data-testid="footer-cta"
              className="mt-8 btn-hard-invert inline-flex items-center gap-2 bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-6 py-3 border border-[#F4F4EB]"
            >
              Get a Quote
            </Link>
          </div>

          <div className="md:col-span-4 grid grid-cols-2 gap-6">
            <div>
              <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
                Services
              </div>
              <ul className="space-y-2 text-sm">
                {col1.map((s) => (
                  <li key={s.slug}>
                    <Link
                      to={`/services/${s.slug}`}
                      className="hover:text-[#E5231A] transition-colors"
                    >
                      {s.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
                &nbsp;
              </div>
              <ul className="space-y-2 text-sm">
                {col2.map((s) => (
                  <li key={s.slug}>
                    <Link
                      to={`/services/${s.slug}`}
                      className="hover:text-[#E5231A] transition-colors"
                    >
                      {s.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
              Contact
            </div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href="tel:+13255133501"
                  data-testid="footer-phone"
                  className="flex items-start gap-3 hover:text-[#E5231A] transition-colors"
                >
                  <Phone size={18} weight="fill" className="mt-0.5 text-[#E5231A]" />
                  <span className="font-display font-extrabold text-lg">(325) 513-3501</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:m.schaefer@schaeferservicestx.com"
                  data-testid="footer-email"
                  className="flex items-start gap-3 hover:text-[#E5231A] transition-colors break-all"
                >
                  <EnvelopeSimple size={18} weight="fill" className="mt-0.5 text-[#E5231A]" />
                  <span>m.schaefer@schaeferservicestx.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} weight="fill" className="mt-0.5 text-[#E5231A]" />
                <span>Abilene, TX &amp; Surrounding</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="relative border-t border-[#333333]">
        <div className="overflow-hidden whitespace-nowrap select-none">
          <div
            className="font-display font-black uppercase tracking-tighter text-[#E5231A]/90 leading-none py-4 md:py-6"
            style={{ fontSize: "clamp(3rem, 14vw, 14rem)" }}
          >
            BUILT IN TEXAS
          </div>
        </div>
      </div>

      <div className="relative border-t border-[#333333]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-[#F4F4EB]/50 uppercase tracking-widest">
          <div>© {year} Schaefer Services · Michael Schaefer, Owner</div>
          <div>Abilene, Texas · Licensed &amp; Insured</div>
        </div>
      </div>
    </footer>
  );
}
